  document.addEventListener("DOMContentLoaded", function () {
    const showMapButtons = document.querySelectorAll(".button-action.csv");

    showMapButtons.forEach(function (button) {
      button.addEventListener("click", function (e) {
        e.preventDefault();
        console.log("test")
        const mapUrl = button.dataset.mapCsv;
        console.log("🚀 ~ mapUrl:", mapUrl)

        window.location.href = mapUrl;
      });
    });
  });

